@if (backButton) {
  <div>
    <button class="flex-initial" mat-raised-button color="primary" (click)="pressBackToEdit()">
      <mat-icon class="materialSendIcon">arrow_back</mat-icon>
      <span class="customSendIconLeft"></span>
      <span
        [innerHtml]="'ticket.create.confirm.button__back_to_edit' | translate | uppercase"
      ></span>
    </button>
  </div>
}
@if (showTicketCreateData) {
  <div [style.margin-bottom.px]="80">
    <h2 [innerText]="translateKeyTitle | translate"></h2>
    <p [innerText]="translateKeyDescription | translate" class="confirm-value"></p>
  </div>
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__short_title' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[0]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__short_description' | translate"></span>:
    </div>
  </div>
  <br />
  <div>
    <span class="confirm-value">{{ filledForm[1]?.value }}</span>
  </div>
  <br />
  <br />
  <div class="confirm-row">
    <div class="d-flex flex-row flex-1 gap-10">
      <div class="confirm-chapter-hr-div flex-1 hide-lt-sm" [style.padding-top.px]="22">
        <hr class="confirm-chapter-hr" />
      </div>
      <div class="flex-initial">
        <h3
          [innerText]="'ticket.create.confirm.headline__objectAdress' | translate"
          class="confirm-chapter-headline"
        ></h3>
      </div>
      <div class="confirm-chapter-hr-div flex-1" [style.padding-top.px]="22">
        <hr class="confirm-chapter-hr" />
      </div>
    </div>
  </div>
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.confirm.label__placeholder' | translate"></span>:
    </div>
    <span class="confirm-value flex-1"
      >{{ filledForm[4]?.value?.siteName }}, {{ filledForm[4]?.value?.address?.city }},
      {{ filledForm[4]?.value?.address?.streetName }}</span
    >
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.confirm.label__roomNumber' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[5]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.confirm.label__floor' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[7]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.confirm.label__section' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[8]?.value }}</span>
  </div>
  <br />
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.confirm.label__differentAddress' | translate"></span>:
    </div>
  </div>
  <br />
  <div>
    <span>{{ filledForm[9]?.value }}</span>
  </div>
  <br />
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__salution' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[13]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__jobtitel' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[14]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__firstName' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[15]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__lastName' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[16]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__phoneNumber' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[17]?.value }}</span>
  </div>
  <br />
  <div>
    <div class="confirm-label flex-1">
      <span [innerText]="'ticket.create.label__email' | translate"></span>:
    </div>
    <span class="confirm-value flex-1">{{ filledForm[18]?.value }}</span>
  </div>
} @else {
  <div [style.margin-bottom.px]="80">
    <h2 [innerText]="translateKeyTitle | translate"></h2>
    <p [innerText]="translateKeyDescription | translate" class="confirm-value"></p>
  </div>
  @for (field of filledForm; track field) {
    <div>
      @if (field.visibleInConfirm) {
        <div class="confirm-row">
          @switch (field.type) {
            @case ('textarea') {
              <div class="flex-1">
                <strong>
                  <p [innerText]="field.label + ':'"></p>
                </strong>
                <div style="overflow-wrap: anywhere" [innerText]="field.value"></div>
              </div>
            }
            @case ('formly-template') {
              <div class="flex-1" [innerHtml]="field.data.template"></div>
            }
            @case ('chapter') {
              <div class="d-flex flex-row flex-1 gap-10">
                <div class="confirm-chapter-hr-div flex-1 hide-lt-sm" [style.padding-top.px]="22">
                  <hr class="confirm-chapter-hr" />
                </div>
                <div class="flex-initial">
                  <h3 [innerHtml]="field.label" class="confirm-chapter-headline"></h3>
                </div>
                <div class="confirm-chapter-hr-div flex-1" [style.padding-top.px]="22">
                  <hr class="confirm-chapter-hr" />
                </div>
              </div>
            }
            @case ('matdatetimepicker') {
              <div class="confirm-label flex-1"><span [innerText]="field.label"></span>:</div>
              <div class="confirm-value flex-1">
                <!-- field.value ist bereits in formatDateTime() (moment) formatiert; die
           fruehere zusaetzliche DatePipe bekam ein moment-Format (YYYY) und
           wirft seit Angular 21 (NG02300) -> Rendering der View brach ab. -->
                <span>
                  {{ field.value }}
                </span>
              </div>
            }
            @case ('select') {
              <div class="confirm-label flex-1"><span [innerText]="field.label"></span>:</div>
              <div class="confirm-value flex-1" [innerText]="field.value"></div>
            }
            @case ('tree-select') {
              <div class="confirm-label flex-1"><span [innerText]="field.label"></span>:</div>
              <div class="confirm-value flex-1" [innerText]="field.value"></div>
            }
            @case ('pasm-autocomplete') {
              <div class="confirm-label flex-1"><span [innerText]="field.label"></span>:</div>
              <div class="confirm-value flex-1">
                @if (field.value.siteName) {
                  <span>{{ field.value.siteName }};</span>
                }
                @if (field.value.siteAdditionalNumber) {
                  <span>{{ field.value.siteAdditionalNumber }};</span>
                }
                @if (field.value.vpsz) {
                  <span>{{ field.value.vpsz }};</span>
                }
                @if (field.value.address?.streetName) {
                  <span>
                    {{ field.value.address.streetName }},
                    {{ field.value.address.postalCode }}
                    {{ field.value.address.city }}
                  </span>
                }
              </div>
            }
            @default {
              <div class="confirm-label flex-1"><span [innerText]="field.label"></span>:</div>
              <div class="confirm-value flex-1" [innerText]="field.value"></div>
            }
          }
        </div>
      }
    </div>
  }
}

<hr />

<form (ngSubmit)="validateConfirmedForm()" [formGroup]="extraConfirmForm">
  <div>
    <formly-form
      [form]="extraConfirmForm"
      [fields]="extraConfirmFormFields"
      [model]="extraConfirmFormModel"
    ></formly-form>
    @if (dsgvoUrl && dsgvoUrl !== '') {
      <div class="d-flex flex-row" [style.margin]="'20px 0px'">
        <a class="flex-1 d-flex flex-row" [href]="dsgvoUrl" target="_blank">
          <mat-icon>description</mat-icon>
          <span [innerText]="'ticket.create.confirm.label__dsgvo_link' | translate"></span>
        </a>
      </div>
    }
  </div>

  <div class="confirm-actions">
    <button type="button" mat-raised-button color="primary" (click)="pressBackToEdit()">
      <span class="customSendIconLeft"></span>
      <mat-icon class="materialSendIcon">arrow_back</mat-icon>
      <span [innerText]="'ticket.create.confirm.button__back_to_edit' | translate"></span>
    </button>
    <button type="submit" mat-raised-button color="accent">
      <span class="customSendIconRight"></span>
      <span [innerText]="'ticket.create.confirm.button__send' | translate"></span>&nbsp;
      <mat-icon class="materialSendIcon">send</mat-icon>
    </button>
  </div>
</form>
